import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

const CancellationPolicy = ({
  pageView,
  cancelUpdateObj = {},
  isFnb,
  creditRefundSelected,
  viewAs,
  intl
}) => {
  const guestView = 'guest' === viewAs.toLowerCase();
  const refundPercentage = cancelUpdateObj.refund_percentage;
  const policyName = _.get(cancelUpdateObj, 'cancellation_policy.name', '');
  const zendeskLocale = SharedIntlProviderHOC.getZendeskLocale();
  const guestViewText = guestView
    ? intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.processing_fee', defaultMessage: 'the processing fee' })
    : intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.peerspace_fee', defaultMessage: 'Peerspace fees.' });

  const refundableItemText = intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.refunded', defaultMessage: '{isFnb} are refunded if the booking has not taken place.' },
    { isFnb: isFnb
      ? intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.tax', defaultMessage: 'Tax and tip' })
      : intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.fees', defaultMessage: 'Cleaning fees' })
    });
  const creditRefundText = intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.used_towards', defaultMessage: 'in Peerspace credit which can be used towards any booking in the future.' });
  const refundTextObj = {
    cancelForm: {
      '0%': intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.non_refundable', defaultMessage: 'This cancellation request is non-refundable. {refundable}' }, { refundable: refundableItemText }),
      '50%': intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.receive_50_percent', defaultMessage: 'If you cancel now, you will receive a 50% refund minus the processing {refundSelected} {refundableText}' }, {
        refundSelected: creditRefundSelected
          ? intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.receive_50_percent_fee_text', defaultMessage: 'fee {creditRefundText}' }, { creditRefundText: creditRefundText })
          : intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.receive_50_percent_fee', defaultMessage: 'fee.' }),
        refundableText: refundableItemText
      }),
      '100%': intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.full_refund', defaultMessage: 'If you cancel now, you will receive a full {refundSelected}' }, {
        refundSelected: creditRefundSelected
          ? intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.full_refund_refund_text', defaultMessage: 'refund {creditRefundText}' }, { creditRefundText: creditRefundText })
          : intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.full_refund_refund', defaultMessage: 'refund.' })
      })
    },
    cancelSummary: {
      '0%': intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.cancellation_non_refund', defaultMessage: 'This cancellation was non-refundable. {refundableText}' }, { refundableText: refundableItemText }),
      '50%': intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.resulted_50', defaultMessage: 'This cancellation resulted in a 50% refund minus the {creditRefund} {refundableText}' },{
        creditRefund: guestView
          ? creditRefundSelected
            ? intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.resulted_50_guest_text', defaultMessage: '{guestText} {creditRefundText}' }, { creditRefundText: creditRefundText, guestText: guestViewText })
            : intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.resulted_50_guest', defaultMessage: '{guestText}.' }, { guestText: guestViewText })
          : '',
        refundableText: refundableItemText
      }),
      '100%': intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.resulted_full_refund', defaultMessage: 'This cancellation resulted in a full {creditRefundText}' }, {
        creditRefundText: guestView && creditRefundSelected
          ? intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.resulted_full_refund_text', defaultMessage: 'refund {creditRefundText}' }, { creditRefundText: creditRefundText })
          : intl.formatMessage({ id: 'inbox_id_cancel_booking.cancellation_policy.resulted_full_refund_dot', defaultMessage: 'refund.' })
      })
    }
  };

  return (
    <div className="cancellation-policy-container">
      <h6>{policyName}</h6>
      <p>
        {refundTextObj[pageView][refundPercentage] || ''}
        <a href={`https://support.peerspace.com/hc/${zendeskLocale}/articles/210458203-What-is-the-cancellation-and-refund-policy`} target="_blank" rel="noopener noreferrer"> <FormattedMessage id='inbox_id_cancel_booking.cancel_booking_main.cancellation_policy' defaultMessage='Go to cancellation policy' /></a>
      </p>
    </div>
  );
};

CancellationPolicy.propTypes = {
  cancelUpdateObj: PropTypes.object,
  pageView: PropTypes.string,
  viewAs: PropTypes.string,
  isFnb: PropTypes.bool,
  creditRefundSelected: PropTypes.bool,
  intl: intlShape
};

export default injectIntl(CancellationPolicy);
